import posthog from 'posthog-js'

const enabled = import.meta.env.VITE_POSTHOG_ENABLED === 'true'

if (enabled) {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        capture_pageview: true,
        capture_pageleave: true,
        capture_exceptions: true,
        session_recording: {
            maskAllInputs: false,
        },
        debug: import.meta.env.VITE_POSTHOG_DEBUG_MODE === 'true',
    })
}

export const posthogClient = enabled ? posthog : null
